import { BOT_MONITOR_STATUSES } from "../constants/botMonitor"
import { BotMonitorFilters, BotMonitorQuery } from "../interfaces/botMonitor"

type AppliedFilters = Pick<BotMonitorQuery, "search" | "status" | "archived">

/** Comparison only: transport preserves case and every leading @. */
export const areBotMonitorFiltersEquivalent = (
  left: AppliedFilters,
  right: AppliedFilters,
): boolean => {
  const searchKey = (search = "") =>
    (search.startsWith("@") ? search.slice(1) : search).toLowerCase()
  const statusKey = (filters: AppliedFilters) =>
    BOT_MONITOR_STATUSES.filter(
      (status) => filters.status?.includes(status) ?? true,
    ).join(",")
  return (
    searchKey(left.search) === searchKey(right.search) &&
    statusKey(left) === statusKey(right) &&
    left.archived === right.archived
  )
}

export const validateBotMonitorFilters = (filters: BotMonitorFilters) => {
  const errors: Partial<Record<"search" | "status", string>> = {}
  const search = filters.search.trim()
  const effective = search.startsWith("@") ? search.slice(1) : search
  if (Array.from(effective).length > 100)
    errors.search = "Поиск: не более 100 символов после удаления одного @"
  if (
    !filters.status.length ||
    filters.status.some((status) => !BOT_MONITOR_STATUSES.includes(status))
  )
    errors.status = "Выберите допустимые статусы"
  if (Object.keys(errors).length) return { ok: false as const, errors }
  return {
    ok: true as const,
    filters: {
      search: effective.length ? search : "",
      status: BOT_MONITOR_STATUSES.filter((status) =>
        filters.status.includes(status),
      ),
      archived: filters.archived,
    },
  }
}

/** Only typed domain keys reach the API, with status encoded as CSV. */
export const botMonitorRequestParams = (query: BotMonitorQuery) => ({
  limit: query.limit,
  offset: query.offset,
  archived: query.archived,
  sortBy: query.sortBy,
  order: query.order,
  ...(query.search === undefined ? {} : { search: query.search }),
  ...(query.status === undefined ? {} : { status: query.status.join(",") }),
})
